import React, { useEffect } from 'react'
import { ConfirmationPage } from '@wallyhealth/web-core'
import intelService from '../../../services/intelService'
import styles from './index.module.css'

const PAGE_NAME = 'StandbyScheduledPage'

const StandbyScheduledPage = () => {
  useEffect(() => {
    intelService.recordView({ viewName: PAGE_NAME })
  }, [])

  return (
    <ConfirmationPage
      title="All set!"
      titleClassName={styles.title}
      subtitle="Your appointment is confirmed."
    />
  )
}

export default StandbyScheduledPage
